/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ city: NonNullable<unknown> }} Directory_Meta_Description_CityInputs */

const en_directory_meta_description_city = /** @type {(inputs: Directory_Meta_Description_CityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trainers, dieticians and physios in ${i?.city} with prices and open times. Book online, no account needed to browse.`)
};

const pl_directory_meta_description_city = /** @type {(inputs: Directory_Meta_Description_CityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trenerzy, dietetycy i fizjoterapeuci w mieście ${i?.city} z cenami i wolnymi terminami. Umów się online, przeglądasz bez konta.`)
};

/**
* | output |
* | --- |
* | "Trainers, dieticians and physios in {city} with prices and open times. Book online, no account needed to browse." |
*
* @param {Directory_Meta_Description_CityInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_meta_description_city = /** @type {((inputs: Directory_Meta_Description_CityInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Meta_Description_CityInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_meta_description_city(inputs)
	return en_directory_meta_description_city(inputs)
});